import initHeaderLangSwitcher from "./lang-switcher";
import initHeaderMobileMenu from "./mobile-menu";

document.addEventListener("DOMContentLoaded", () => {
	initHeaderLangSwitcher();
	initHeaderMobileMenu();
});
